"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A = exports.ACSS = void 0;

var styled_components_1 = __importStar(require("styled-components"));

var TypographyCSS_1 = require("./TypographyCSS");

var theme_1 = require("../theme");

exports.ACSS = (0, styled_components_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-decoration: none;\n  &,\n  &:visited,\n  &:active {\n    color: ", ";\n  }\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n    cursor: pointer;\n  }\n"])), function (props) {
  var _a, _b;

  if (props.color && ((_a = theme_1.theme.colors[props.color]) === null || _a === void 0 ? void 0 : _a[500]) != null) {
    return (_b = theme_1.theme.colors[props.color]) === null || _b === void 0 ? void 0 : _b[500];
  }

  return theme_1.theme.colors.brand[500];
}, function (props) {
  if (props.color && theme_1.theme.colors[props.color] != null) {
    return theme_1.theme.colors[props.color][300];
  }

  return theme_1.theme.colors.brand[100];
});
exports.A = styled_components_1.default.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), exports.ACSS, TypographyCSS_1.TypographyCSS);